import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION7: PdfComponent = {
  type: 'section',
  id: 'iars7',
  title: '7. Scope of Activities',
  content: [
    {
      type: 'bulletList',
      id: 'iars7bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'All documentation and materials provided by the Principal are its property and must be returned upon termination.',
        },
        {
          copy: {
            type: 'altText',
            id: 'iar22',
            content: [
              'The Introducer shall not use or disclose any ',
              'Confidential Information',
              ', except as required by law or regulators.',
            ],
            boldFirst: false,
          },
        },
      ],
      prefix: '7',
    },
  ],
};
